const enTranslation = {
    // Common
    language: "English",
    months: {
        jan: "January",
        feb: "February",
        mar: "March",
        apr: "April",
        may: "May",
        jun: "June",
        jul: "July",
        aug: "August",
        sep: "September",
        oct: "October",
        nov: "November",
        dec: "December"
    },
    weekDays: {
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun"
    },

    // Navigation
    navigation: {
        features: "Features",
        aboutUs: "About Us",
        pricing: "Pricing",
        partners: "Partners",
        contact: "Contact",

        login: "Log In",
        dashboard: "Dashboard"
    },

    // Footer
    footer: {
        aboutDrivn: "About Drivn",
        resources: "Resources",
        legal: "Legal",
        linkedIn: "LinkedIn",
        faq: "FAQ",
        customerSupport: "Contact Us",
        contactUs: "Contact Sales",
        privacyPolicy: "Privacy Policy",
        termsConditions: "Terms & Conditions",
        rights: "All Rights Reserved."
    },

    // Pricing page
    pricing: {
        badge: "Pricing",
        title: "Pricing",
        subtitle: "Make CO₂ measurable without the paperwork",
        setupFee: "setup fee",
        bookMeeting: "Book a meeting",
        Pricing: "Pricing",
        custom: "Custom",
        contactSales: "Contact sales",
        perProject: "per project",
        perCompany: "per company",
        perYear: "/ year",
        groups: {
            coreServices: {
                title: "Workforce & Operations",
                description: "Streamline employee management, time tracking, and compliance with our subscription-based services."
            },
            customSolutions: {
                title: "Sustainability & Compliance",
                description: "Tailored environmental impact tracking and regulatory compliance solutions for your projects."
            }
        },
        features: {
            fast: "Fast and reliable",
            fastDesc: "We've made it fast and reliable."
        },
        plans: {
            timeRegistration: {
                name: "Time Registration",
                description: "Simple, mandatory and cost-effective time tracking solution",
                features: {
                    legalCompliance: {
                        title: "Legal Compliance",
                        description: "EU & Danish work time regulations"
                    },
                    automaticTracking: {
                        title: "Automatic Tracking",
                        description: "Precise GPS tracking, geofencing & mobile login"
                    },
                    userFriendly: {
                        title: "User-Friendly Interface",
                        description: "Works on all devices"
                    },
                    timePolicy: {
                        title: "Time registration policy",
                        description: "495 per contract"
                    }
                }
            },
            drivingAllowance: {
                name: "Driving Allowance",
                description: "Eliminate manual registration and ensure tax-compliant mileage reimbursement",
                features: {
                    gpsTracking: {
                        title: "GPS-Based Tracking",
                        description: "Automatic precise mileage documentation"
                    },
                    taxCompliance: {
                        title: "Tax Authority Compliance",
                        description: "Calculations according to tax rules"
                    },
                    accounting: {
                        title: "Accounting Integration",
                        description: "Export data to financial systems"
                    },
                    dashboard: {
                        title: "Management Dashboard",
                        description: "Oversight and approval workflows"
                    }
                }
            },
            co2: {
                name: "Drivn CO₂",
                description: "Track and reduce your company's carbon footprint",
                features: {
                    automatedCalc: {
                        title: "Automated Calculations",
                        description: "Precise CO₂ emission tracking"
                    },
                    dashboard: {
                        title: "Real-time Dashboard",
                        description: "Visual analytics and monitoring"
                    },
                    esgCompliance: {
                        title: "ESG Compliance",
                        description: "Regulatory reporting support"
                    },
                    integration: {
                        title: "System Integration",
                        description: "Works with your existing software"
                    }
                }
            },
            allInOne: {
                name: "All-in-One solution for Workforce & Operations",
                description: "Integrate time tracking, mileage reimbursement and CO₂ monitoring in one unified platform",
                features: {
                    complete: {
                        title: "Complete Solution",
                        description: "All modules in one integrated package"
                    },
                    reporting: {
                        title: "Consolidated Reporting",
                        description: "Combined analytics and dashboards"
                    },
                    integration: {
                        title: "Enterprise Integration",
                        description: "Seamless connection to your systems"
                    }
                },
                popular: "Popular"
            },
            lcaA4: {
                name: "LCA A4",
                description: "Automated tracking of construction transport emissions for LCA A4 compliance.",
                features: {
                    transportModes: {
                        title: "Transport tracking",
                        description: "Automatic data for all project transport."
                    },
                    payloadUtil: {
                        title: "Payload & efficiency",
                        description: "Load factors, empty runs and utilization accounted."
                    },
                    fuel: {
                        title: "Fuel types",
                        description: "Accurate emission factors per fuel type."
                    }
                }
            },
            packaging: {
                name: "Producer Responsibility",
                description: "CO₂ and EPR fee estimates for packaging with recyclability checks.",
                features: {
                    components: {
                        title: "Components, materials & weights",
                        description: "Enter per-component materials, formats and weights."
                    },
                    co2Factors: {
                        title: "Automatic CO₂ factors",
                        description: "Material and market-specific emission factors applied."
                    },
                    epr: {
                        title: "EPR fee estimates (EU 2025)",
                        description: "Country-specific estimates aligned to new EU requirements."
                    },
                    reporting: {
                        title: "Recyclability & reporting",
                        description: "Design checks, comparisons and exportable PDF/CSV."
                    }
                }
            },
            scope12: {
                name: "Scope 1 & 2",
                description: "Register energy consumption and calculate CO₂ across direct and indirect emissions.",
                features: {
                    autoCalc: {
                        title: "Automatic CO₂ calculation",
                        description: "Emissions calculated from energy type, site location and relevant factors."
                    },
                    municipalFactors: {
                        title: "Municipality-specific factors",
                        description: "Energinet environmental declarations (125% method) applied per site."
                    },
                    pdfUpload: {
                        title: "PDF invoice upload",
                        description: "AI-powered data extraction with manual validation."
                    },
                    dashboard: {
                        title: "Dashboard & reporting",
                        description: "Visual CO₂ trends, filtering by period and exportable PDF reports."
                    }
                }
            }
        },
        perMonth: "/ month",
        perUserPerMonth: "/ user / month",
        perContract: "per contract",
        viewAllServices: 'View all services',
        otherServices: {
            title: 'Other services',
            description: 'Explore all our services and pricing',
            features: {
                timeRegistration: {
                    title: 'Time registration',
                    description: 'Compliant, automated tracking and user-friendly mobile experience.'
                },
                drivingAllowance: {
                    title: 'Driving allowance',
                    description: 'GPS-based mileage tracking with tax-compliant reporting.'
                },
                co2: {
                    title: 'CO₂ tracking',
                    description: 'Automated emissions calculation and ESG-ready dashboards.'
                }
            }
        }
    },

    // Plan names
    plans: {
        timeRegistration: "Time Registration",
        drivingAllowance: "Driving Allowance",
        growth: "Growth",
        enterprise: "Enterprise"
    },

    // Plan descriptions
    planDescriptions: {
    },

    // Login page
    login: {
        title: "Log in to your account",
        email: "Your email",
        emailPlaceholder: "name@company.com",
        password: "Password",
        passwordPlaceholder: "••••••••",
        rememberMe: "Remember me",
        forgotPassword: "Forgot password?",
        loginButton: "Log in"
    },

    // Contact Sales page
    contactSales: {
        title: "Contact Sales"
    },

    // Features page
    features: {
        title: "Features",
        subtitle: "Powerful features for your business",
        description: "We provide tools that help you manage your business efficiently."
    },

    // Overview page
    overview: {
        title: "Overview",
        subtitle: "Your business at a glance",
        description: "Get a comprehensive view of your business performance."
    },

    // Home page
    home: {
        main: {
            title: "Make CO₂ Tracking Measurable, Manageable, and Compliant",
            subtitle: "Empower your business with intuitive tools for accurate CO₂ tracking, seamless management, and effortless compliance",
            getStartedButton: "Get Started",
            learnMoreButton: "Learn More"
        },
        cta: {
            titleStart: "Ready to get",
            titleAccent: "started?",
            subtitle: "Talk to our team about how Drivn can help your business",
            emailButton: "Email our team",
            bookMeeting: "Book a meeting"
        },
        overviewSection: {
            app: {
                title: "Drivn App: Empower Your Employee's Eco-Conscious Commute",
                description: "Elevate your employee's daily commute with the Drivn App. Designed with simplicity and sustainability in mind, our app enables effortless registration and management of employee's travel. Track carbon footprint, join green initiatives, and support environmental goals automatically.",
                features: {
                    registration: {
                        title: "Seamless Registration:",
                        text: "Sign up with your organization's code in seconds."
                    },
                    noEngage: {
                        title: "No need to engage in the app:",
                        text: "Automatically logs in the background with zero input needed."
                    },
                    realTime: {
                        title: "Real-Time Data:",
                        text: "View your work related transportation emissions in real time."
                    },
                    greenGoals: {
                        title: "Green Goals:",
                        text: "Join company challenges and contribute to sustainability targets."
                    }
                }
            },
            dashboard: {
                title: "Drivn Dashboard: Insightful Oversight for Sustainability",
                description: "Transition to transparent and automated carbon accounting with Drivn's Dashboard. Managers gain a comprehensive view of the company's transportation emissions and trends. Harness the power of data to drive strategic decisions, meet compliance, and lead the way in corporate responsibility.",
                features: {
                    aggregated: {
                        title: "Aggregated Data:",
                        text: "Get a bird's-eye view of company-wide commuting data."
                    },
                    compliance: {
                        title: "Compliance Simplified:",
                        text: "Tools tailored to meet CSRD and ESG reporting."
                    },
                    insights: {
                        title: "Actionable Insights:",
                        text: "Analyze trends and measure the effectiveness of green policies."
                    },
                    engage: {
                        title: "Engage and Educate:",
                        text: "Access resources to foster a culture of sustainability."
                    }
                }
            },
            charts: {
                emissions: {
                    title: "{{totalEmissions}} kg",
                    subtitle: "CO₂ Emissions",
                    seriesName: "Emissions",
                    yAxisLabel: "{{value}}kg"
                },
                commutes: {
                    subtitle: "Amount of Commutes",
                    seriesName: "Commutes"
                },
                distance: {
                    title: "Total Distance",
                    unit: "km",
                    seriesName: "Distance",
                    tooltipFormat: "{{value}} km"
                },
                transport: {
                    mostUtilizedValue: "Car",
                    mostUtilized: "Most Utilized Transportation Method",
                    tooltipFormat: "{{value}} km",
                    methods: {
                        car: "Car",
                        bus: "Bus",
                        train: "Train",
                        bike: "Bike",
                        walking: "Walking"
                    }
                },
                months: {
                    jan: "Jan",
                    feb: "Feb",
                    mar: "Mar",
                    apr: "Apr",
                    may: "May",
                    jun: "Jun"
                }
            }
        },
        featuresSection: {
            mainTitle: "Designed for sustainability teams like yours",
            mainDescription: "At Drivn we focus on leveraging advanced technologies and creativity to unlock emissions data never seen before",
            highQualityData: {
                title: "High Quality Data",
                description: "Eliminate human error and ensure high-quality data with our fully automatic tracking."
            },
            automated: {
                title: "100% Automated",
                description: "Our mobile app leverages machine learning and adaptive geofencing to automatically identify and calculate emissions from work-related commutes."
            },
            insights: {
                title: "Valuable Insights",
                description: "Educate your employees in their commuting habits and related emissions."
            },
            compliance: {
                title: "Compliance",
                description: "Our web-based admin panel aggregates real-time data, helping you meet CSRD and ESG requirements effortlessly."
            }
        },
        productsSolutions: {
            badge: "Products",
            title: "Our Solutions",
            subtitle: "Discover how Drivn automates mileage tracking, ensures compliance, and integrates smoothly with your workflow.",
            products: {
                tracking: {
                    id: "tracking",
                    title: "Drivn CO₂ tracking",
                    description: "Drivn CO₂ is an innovative and user-friendly system that helps companies record, monitor and reduce their carbon footprint. With automated data collection, Drivn CO₂ makes it easy to document environmental impact and meet ESG requirements and regulatory reporting standards.",
                    bulletPoints: [
                        { title: "Automated CO₂ calculation:", text: "Collects and analyzes data from company activities to provide accurate CO₂ reporting." },
                        { title: "Live overview of emissions:", text: "Intuitive dashboard with real-time data and visual analytics." },
                        { title: "Compliance & ESG reporting:", text: "Supports documentation for authorities, investors and certification schemes." },
                        { title: "Optimization of sustainability strategies:", text: "Identifies CO₂-heavy processes and suggests effective reduction measures." },
                        { title: "Integration with existing systems:", text: "Easy setup and compatibility with finance, transport and production software." },
                    ],
                    additionalInfo: "Our CO₂ tracking solution is designed to help your business meet sustainability goals while simplifying regulatory compliance. The system adapts to your specific industry needs."
                },
                driving: {
                    id: "compliance",
                    title: "Drivn Automated Driving Allowance",
                    description: "Drivn offers an automated driving allowance solution that eliminates manual registration and ensures accurate calculations in accordance with the Danish Tax Agency's regulations. With GPS tracking and automatic logging of kilometers driven, the system reduces administrative burdens and minimizes the risk of errors.",
                    bulletPoints: [
                        { title: "Automatic driving allowance registration:", text: "GPS-based registration ensures accurate documentation of kilometers driven" },
                        { title: "Complies with tax requirements:", text: "The system calculates and documents driving allowance according to applicable legislation." },
                        { title: "Integration with accounting systems:", text: "Export data directly to the company's financial system for easy bookkeeping." },
                        { title: "Time-saving solution:", text: "Eliminates the need for manual driving accounts and reduces administrative work." },
                        { title: "User-friendly mobile and web platform:", text: "Employees can easily approve and submit driving data with a few clicks." },
                        { title: "Increased transparency and control:", text: "Managers get a clear overview of employees' business driving." }
                    ],
                    additionalInfo: "With Drivn Automated Driving Allowance, companies get a reliable and scalable solution that ensures correct registration, reduces time consumption and makes it easier to comply with regulatory requirements."
                },
                timeRegistration: {
                    id: "integration",
                    title: "Drivn Time Regisration",
                    description: "Drivn offers the market's most user‑friendly and affordable Time Regisration system, ensuring your company complies with working‑time legislation and giving you a clear overview of employees' hours. With a fully digital and automated solution, Drivn makes time registration easy for both employees and managers while safeguarding the business legally.",
                    bulletPoints: [
                        { title: "Mandatory time tracking", text: "Complies with the EU Working Time Directive and Danish working‑time regulations." },
                        { title: "Automatic recording:", text: "Accurate logging of working hours via GPS, geofencing, and mobile login." },
                        { title: "Simple interface:", text: "Employees can clock in and out effortlessly using a smartphone, tablet, or desktop." },
                        { title: "Full flexibility:", text: "Supports fixed schedules, shift work, and flexible hours." },
                        { title: "Reports and payroll integration:", text: "Generates clear reports and integrates with payroll systems." }
                    ],
                    additionalInfo: "With Drivn, you get a Time Regisration system that saves time, ensures compliance, and reduces administrative burden. The solution suits companies of all sizes that want efficient, hassle‑free registration of working hours."
                },
                lca: {
                    id: "lca",
                    title: "Drivn LCA A4 Transport",
                    description: "Drivn LCA A4 Transport automates the collection and documentation of transport emissions (LCA A4) to and from construction sites, so your company can meet life cycle assessment requirements without spreadsheets and manual data gathering. From July 1, 2025, construction CO₂ emissions must be documented, and Drivn makes it straightforward to stay compliant from day one.",
                    bulletPoints: [
                        { title: "A4 compliance ready:", text: "Automatically collects and structures the transport data required for the A4 category in life cycle assessments, so you always have audit-ready documentation." },
                        { title: "Real-time data collection:", text: "Transport emissions are captured live as deliveries and trips happen, giving you up-to-date project data without waiting for manual reports." },
                        { title: "Limit value alerts:", text: "The system monitors your project's CO₂ against the BR18 limit value and sends alerts if you are approaching the threshold, so you can act before it is too late." },
                        { title: "Supplier and subcontractor data:", text: "Collect emissions data from suppliers and subcontractors through the industry-wide supplier database and link it directly to the relevant construction site." },
                        { title: "Certification support:", text: "Export project data in formats compatible with DGNB, BREEAM, and other green building certification systems to support your sustainability goals." },
                        { title: "Project-level dashboards:", text: "Get a clear visual overview of transport emissions per project, compare sites, and track progress toward your targets over time." }
                    ],
                    additionalInfo: "Built in collaboration with CG Jensen, Drivn LCA A4 Transport gives construction companies and developers a reliable and scalable way to document transport emissions, reduce manual work, and stay ahead of regulatory requirements."
                },
                packaging: {
                    id: "packaging",
                    title: "Drivn Producer Responsibility",
                    description: "Drivn Producer Responsibility makes it easy to manage your packaging data, calculate environmental impact, and generate VANA-compliant reports for Extended Producer Responsibility (EPR) obligations.",
                    bulletPoints: [
                        { title: "Product register:", text: "Maintain a complete register of your products with GTIN, packaging components, and material details." },
                        { title: "Easy data import:", text: "Upload product and sales data via Excel/CSV or add products manually with our guided flow." },
                        { title: "Automated VANA reporting:", text: "Generate quarterly, monthly, or custom-period reports that meet VANA requirements in just a few steps." },
                        { title: "Weight and recyclability tracking:", text: "Track total packaging weight and recyclability rates across your product portfolio." },
                        { title: "Dashboard overview:", text: "Get a clear overview of products, sold units, reports, and compliance status from a single dashboard." }
                    ],
                    additionalInfo: "Whether you have a handful of products or thousands, Drivn Producer Responsibility streamlines your EPR workflow so you can stay compliant with minimal effort."
                },
                scope12: {
                    id: "scope12",
                    title: "Drivn Scope 1 & 2",
                    description: "Track your company's energy consumption and calculate CO₂ emissions across both direct and indirect sources, all in one platform.",
                    bulletPoints: [
                        { title: "Full emissions overview:", text: "Monitor Scope 1 (fuel, gas) and Scope 2 (purchased electricity) from a single dashboard." },
                        { title: "Automated CO₂ calculations:", text: "Upload invoices or enter consumption data and let the platform calculate emissions automatically." },
                        { title: "Location-aware precision:", text: "Scope 2 factors are matched to your site's municipality using official Energinet environmental declarations." },
                        { title: "AI-powered data entry:", text: "Smart PDF extraction reads your invoices and captures energy data, reducing manual work and errors." },
                        { title: "Reporting & insights:", text: "Track performance over time with dashboards, filtering, and export-ready reports." }
                    ],
                    additionalInfo: "Built for companies at any stage of their sustainability journey, from first measurements to scaled reporting."
                }
            }
        },
        newProducts: {
            tag: "New Products",
            title: "Construction Transportation Emissions Tracking and Producer Responsibility",
            lca: {
                title: "Drivn LCA A4 Transport",
                date: "From July 1, 2025",
                dateText: ", construction CO₂ emissions must be documented—not just estimated.",
                description: "Built with CG Jensen, Drivn LCA A4 Transport automates the collection and documentation of transportation emissions (LCA A4) to and from construction sites, making compliance straightforward.",
                keyFeatures: "Key Features:",
                feature1: "Automatically collects transport data (A4) in real time",
                feature2: "Calculates CO₂ emissions directly in relation to the limit value in BR18",
                feature3: "Provides live alerts if the project is approaching overrun",
                feature4: "Collects data from suppliers and subcontractors",
                databaseTitle: "Industry-Wide Supplier Database",
                databaseDesc: "Our supplier database helps suppliers without digital solutions link their emissions data directly to construction sites—available for the entire industry."
            },
            packaging: {
                title: "Drivn Producer Responsibility",
                date: "From October 1, 2025",
                dateText: ", Extended Producer Responsibility (EPR) fees come into effect across the EU—requiring accurate packaging impact reporting.",
                description: "Drivn Producer Responsibility helps brands measure packaging emissions, estimate EPR fees, and verify recyclability, making compliance and sustainability goals achievable.",
                keyFeatures: "Key Features:",
                feature1: "Automatically calculates CO₂ by material, weight, and format",
                feature2: "Estimates EPR fees based on country-specific regulations",
                feature3: "Provides recyclability guidance and design improvement recommendations",
                feature4: "Enables scenario comparisons for design optimization"
            }
        },
        faq: {
            tag: "FAQ",
            q1: "What products does Drivn offer?",
            a1: "Drivn offers LCA A4 Transport for construction emissions, Producer Responsibility for EPR reporting, Automated Driving Allowance for mileage compliance, and Time Registration for working-time documentation.",
            q2: "How does LCA A4 Transport help with compliance?",
            a2: "It automates collection of transport emissions for the A4 category and provides export-ready documentation to support LCA requirements and green building certifications.",
            q3: "What does Producer Responsibility cover?",
            a3: "It calculates emissions by material and format, estimates EPR fees, and provides guidance on recyclability and design improvements.",
            q4: "How does Automated Driving Allowance work?",
            a4: "GPS-based logging captures business mileage automatically, applies the correct tax rules, and exports data to your accounting or payroll systems.",
            q5: "What can Time Registration help us with?",
            a5: "It makes clock-in and clock-out simple across mobile and desktop, supports flexible schedules and shifts, and delivers clear reports for compliance and payroll.",
            title: "Frequently\nAsked\nQuestions",
            subtitle: "Got any questions? Let us know! Reach out and our team will get right back to you.",
            contact: "Contact us"
        }
    },

    // Contact page
    contact: {
        title: "Have a question?",
        description: "Send it here and our team will get back to you as soon as possible.",
        directEmailPrefix: "You can also contact us directly at",
        email: "Your email",
        emailPlaceholder: "e.g. you@company.com",
        subject: "Question subject",
        subjectPlaceholder: "Briefly describe the subject of your question",
        message: "Your question",
        messagePlaceholder: "Describe your question",
        submit: "Send your question",
        successTitle: "Message sent",
        successBody: "Thanks for your question — we’ll get back to you shortly.",
        successCta: "Got it"
    },

    // FAQ page
    faq: {
        pageTitle: "FAQ",
        title: "Frequently asked questions",
        questions: {
            howItWorks: {
                question: "How does Drivn work?",
                answer: "Drivn utilises a mobile application that employees can download to their smartphones. The app uses geofencing and machine learning to distinguish between personal and work-related transportation. This allows us to automatically provide accurate data on carbon emissions generated during employee commutes. Individual data will be available for the employee directly in the application, while the aggregated data will be displayed through a dashboard in the Drivn admin panel."
            },
            benefits: {
                question: "What are the benefits of using Drivn?",
                bulletPoints: [
                    "Compliance: Drivn helps businesses comply with environmental regulations by providing real-time data on carbon emissions.",
                    "Employee Engagement: Our platform makes sustainable commuting a friendly competition among employees, fostering a culture of eco-friendly practices.",
                    "Data-Driven Insights: Drivn offers valuable insights into commuting patterns, allowing companies to make informed decisions for a greener future."
                ]
            },
            privacy: {
                question: "How is user privacy protected?",
                answer: "We take user privacy seriously. Drivn adheres to all relevant data protection laws within the EU, and users have control over their data. We provide clear information about the data we collect and how it is used, and users can opt-out or disable location tracking at any time. A data processor agreement in accordance with EU standards and The Danish Data Protection Agency is made between the client and Drivn upon company onboarding. Further information can be found within our Privacy Policy and User Consent."
            },
            getStarted: {
                question: "How can my company get started with Drivn?",
                answer: "Getting started is easy! Simply reach out to our team, and we'll guide you through the setup process. We'll help you customise the app for your organisation, provide training for your employees, and ensure a seamless integration into your sustainability initiatives."
            },
            compliance: {
                question: "Can Drivn help with regulatory compliance?",
                answer: "Absolutely. Drivn is designed to assist businesses in meeting regulatory requirements, especially in the context of GHG Protocol: scope 3 category 7 emissions (Employee Commuting)."
            },
            dataInsights: {
                question: "How frequently does Drivn provide data insights?",
                answer: "Drivn provides real-time insights, allowing businesses to access real time-data and information on commuting patterns and carbon emissions. This ensures that organisations can make timely decisions to reduce their environmental impact."
            },
            userExpectations: {
                question: "What is expected from the user in utilising the Drivn app?",
                answer: "To ensure a seamless experience and accurate data collection, users (employees) are encouraged to follow these guidelines:",
                steps: [
                    "Download and Register: Users should download the Drivn app from the provided link and register using their organisation's unique code.",
                    "Activate Location Services: To enable precise tracking, users must activate the \"allow always\" option of location services for the Drivn app. Drivn utilises location data responsibly and respects user privacy.",
                    "Hereafter, no further engagement is required from the user's perspective, however analytics and statistics is available for the user to view if wanted."
                ]
            },
            transportModes: {
                question: "What types of transportation modes does Drivn cover?",
                answer: "Drivn comprehensively covers various transportation modes, ensuring a complete analysis of your organisation's carbon footprint. The supported modes include:",
                modes: [
                    "Car: Whether it's a company car or personal vehicle, Drivn tracks carbon emissions associated with car commuting.",
                    "Train and Metro: For employees using public transportation, Drivn accurately records emissions related to train travel.",
                    "Walking and Biking: Drivn recognizes sustainable modes of transportation, such as walking and biking, contributing to a holistic view of your environmental impact.",
                    "Bus: Drivn also includes bus transportation in its tracking capabilities.",
                    "Other transportation modes covered: Ferry, Tram, Subway."
                ]
            }
        },
        userConsent: "User Consent"
    },

    // Forgot Password page
    forgotPassword: {
        pageTitle: "Forgot Password",
        title: "Reset your password",
        subtitle: "Enter your email here and we'll send you an email where you can reset your password.",
        email: "Your email",
        emailPlaceholder: "name@company.com",
        resetButton: "Reset Password",
        sending: "Sending Password Reset...",
        error: "An Error Occurred",
        tryAgain: "Try Again",
        checkEmail: "Check your email! (And Spam)",
        goToLogin: "Go To Log In"
    },

    // Not Found page
    notFound: {
        pageTitle: "404",
        title: "Page not found",
        subtitle: "Sorry, we couldn't find the page you're looking for.",
        goHome: "Go back home",
        contactSupport: "Contact support"
    },

    termsAndConditions: {
        pageTitle: "Terms and Conditions"
    },

    privacyPolicy: {
        pageTitle: "Privacy Policy"
    },

    knowledgeBank: {
        pageTitle: "Knowledge Bank",
        title: "Knowledge Bank",
        badge: "Resources",
        search: "Search articles...",
        backToSite: "Back to site",
        articles: "articles",
        allCategories: "All Categories",
        hero: {
            title: "How can we help?",
            subtitle: "Find guides, tutorials, and answers to help you get the most out of Drivn"
        },
        featured: {
            title: "Featured Articles"
        },
        help: {
            title: "Can't find what you're looking for?",
            description: "Our support team is here to help you with any questions.",
            cta: "Contact Support"
        },
        navigation: {
            previous: "Previous",
            next: "Next"
        },
        article: {
            placeholder: "This article is being written. Check back soon for the full content.",
            overviewTitle: "Overview",
            keyPointsTitle: "Key Points",
            comingSoon: "Content coming soon..."
        },
        categories: {
            gettingStarted: {
                title: "Getting Started",
                description: "Learn the basics of Drivn and get up and running quickly",
                articles: {
                    introduction: "Introduction to Drivn",
                    quickStart: "Quick Start Guide",
                    accountSetup: "Account Setup"
                },
                descriptions: {
                    introduction: "Learn what Drivn is and how it can help your business",
                    quickStart: "Get started with Drivn in just a few minutes",
                    accountSetup: "Set up your account and configure your organization"
                }
            },
            sustainability: {
                title: "Sustainability",
                description: "Understanding CO₂ tracking and environmental impact",
                articles: {
                    co2Tracking: "CO₂ Tracking",
                    esgReporting: "ESG Reporting",
                    emissionFactors: "Emission Factors"
                },
                descriptions: {
                    co2Tracking: "How Drivn automatically tracks and calculates emissions",
                    esgReporting: "Generate ESG-compliant reports for stakeholders",
                    emissionFactors: "Understanding the emission factors we use"
                }
            },
            compliance: {
                title: "Compliance",
                description: "Meet regulatory requirements with confidence",
                articles: {
                    csrd: "CSRD Compliance",
                    euTaxonomy: "EU Taxonomy",
                    ghgProtocol: "GHG Protocol"
                },
                descriptions: {
                    csrd: "How Drivn helps you comply with CSRD requirements",
                    euTaxonomy: "Understanding the EU Taxonomy and how it applies",
                    ghgProtocol: "Scope 3 emissions and the GHG Protocol"
                }
            },
            timeRegistration: {
                title: "Time Registration",
                description: "Employee time tracking and compliance",
                articles: {
                    setup: "Setting Up Time Registration",
                    mobileApp: "Using the Mobile App",
                    reports: "Time Reports"
                },
                descriptions: {
                    setup: "Configure time registration for your organization",
                    mobileApp: "How employees use the mobile app for time tracking",
                    reports: "Generate and export time registration reports"
                }
            },
            drivingAllowance: {
                title: "Driving Allowance",
                description: "Automated mileage tracking and reimbursement",
                articles: {
                    gpsTracking: "GPS Tracking",
                    taxRules: "Tax Rules",
                    approval: "Approval Workflow"
                },
                descriptions: {
                    gpsTracking: "How GPS-based mileage tracking works",
                    taxRules: "Understanding Danish tax regulations for driving allowance",
                    approval: "Managing approval workflows for driving allowance"
                }
            },
            producerResponsibility: {
                title: "Producer Responsibility",
                description: "EPR compliance and packaging tracking",
                articles: {
                    eprOverview: "EPR Overview",
                    packagingData: "Packaging Data",
                    feeCalculation: "Fee Calculation"
                },
                descriptions: {
                    eprOverview: "Understanding Extended Producer Responsibility",
                    packagingData: "How to input and manage packaging data",
                    feeCalculation: "How EPR fees are calculated"
                }
            },
            faq: {
                title: "FAQ",
                description: "Frequently asked questions and answers",
                articles: {
                    general: "General Questions",
                    technical: "Technical Questions",
                    billing: "Billing Questions"
                },
                descriptions: {
                    general: "Common questions about Drivn and our services",
                    technical: "Technical questions about integrations and data",
                    billing: "Questions about pricing, invoices, and payments"
                }
            }
        }
    },

    partners: {
        pageTitle: "Partners",
        badge: "Strategic Partners",
        title: "Our Partners",
        subtitle: "Working together with industry leaders to deliver comprehensive sustainability solutions",
        visitWebsite: "Visit Website",
        servicesTitle: "What They Offer",
        specialties: {
            esg: "ESG Consulting"
        },
        services: {
            esgStrategy: {
                title: "ESG Strategy Development",
                description: "Comprehensive sustainability roadmaps tailored to your business goals"
            },
            compliance: {
                title: "Regulatory Compliance",
                description: "Navigate CSRD, EU taxonomy, and other ESG reporting requirements"
            },
            reporting: {
                title: "Sustainability Reporting",
                description: "Professional ESG reports that meet stakeholder expectations"
            }
        },
        partnerList: {
            kbConsulting: {
                description: "K & B Consulting is a leading ESG consulting firm specializing in helping businesses navigate the complexities of environmental, social, and governance requirements. With deep expertise in sustainability strategy, ESG reporting, and regulatory compliance, they work alongside Drivn to provide clients with both the data infrastructure and strategic guidance needed to achieve meaningful sustainability outcomes."
            }
        },
        howWeWork: {
            title: "How We Work Together",
            subtitle: "Combining Drivn's technology with expert consulting for complete sustainability solutions",
            steps: {
                data: {
                    title: "Data Collection",
                    description: "Drivn automatically tracks and measures your company's environmental data with precision"
                },
                strategy: {
                    title: "Expert Analysis",
                    description: "K & B Consulting analyzes the data and develops actionable sustainability strategies"
                },
                results: {
                    title: "Real Results",
                    description: "Together we help you achieve compliance, reduce emissions, and meet ESG goals"
                }
            }
        },
        becomePartner: {
            title: "Interested in Partnering with Drivn?",
            description: "We're always looking to collaborate with sustainability experts and consultants who share our vision.",
            cta: "Get in Touch"
        }
    },

    aboutUs: {
        pageTitle: "About Us",
        title: "About Drivn",
        subtitle: "Driving sustainable transportation solutions for modern businesses",
        mission: {
            title: "Our Mission",
            description: "At Drivn, we empower businesses to make data-driven decisions about employee transportation while reducing their environmental impact. We believe that transparency and automation are key to creating a more sustainable future."
        },
        story: {
            title: "Our Story",
            description: "Founded in Denmark, Drivn emerged from the need for accurate, automated transportation data in the corporate world. Traditional methods of tracking employee commutes and business travel were inefficient, prone to error, and lacked the granular insights needed for meaningful environmental impact assessment."
        },
        values: {
            title: "Our Values",
            subtitle: "The principles that guide everything we do",
            sustainability: {
                title: "Sustainability",
                description: "We're committed to helping businesses reduce their carbon footprint through better data and insights."
            },
            transparency: {
                title: "Transparency",
                description: "We provide clear, honest data that helps organizations make informed decisions."
            },
            innovation: {
                title: "Innovation",
                description: "We leverage cutting-edge technology to solve complex transportation challenges."
            },
            privacy: {
                title: "Privacy",
                description: "We prioritize user privacy and data protection in everything we do."
            }
        },
        team: {
            title: "Our Team",
            roles: {
                ceo: "Chief Executive Officer",
                founder: "Founder",
                cto: "Chief Technology Officer",
                fullStackEngineer: "Full Stack Engineer",
                softwareEngineer: "Software Engineer",
                accountManager: "Account Manager"
            }
        },
        contact: {
            title: "Get in Touch",
            description: "Ready to transform your organization's transportation data? Contact us to learn more about how Drivn can help your business."
        }
    },

    // Legend
    legend: {
        title: "Transportation",
        methods: {
            car: "Car",
            bike: "Bike",
            walking: "Walking",
            bus: "Bus",
            train: "Train",
            metro: "Metro"
        }
    },

    // Dashboard
    dashboard: {
        tabs: {
            allowance: "Allowance",
            timeReg: "Time Registration",
            emissions: "CO₂",
            employees: "Employees",
            departments: "Departments",
            offices: "Offices",
            settings: "Settings"
        },
        logout: "Logout",
        organizationCode: "Organization Code:",
        copied: "Copied to clipboard",
        loading: "Loading User...",
        notAdmin: {
            title: "This page is only accessible to admins",
            greeting: "Hi",
            message: "at the moment this page is accessible to admin users. If you should have access to your organization's analytics,",
            contact: "contact your organization administrator at",
            persist: "If the issue persists,",
            support: "contact support"
        },
        allowance: {
            title: "Driving Allowance",
            status: {
                approved: "Approved",
                pending: "Pending",
                rejected: "Rejected"
            },
            monthlyReport: {
                name: "Name",
                distance: "Distance",
                reimbursement: "Reimbursement",
                emissions: "Emissions",
                status: "Status",
                approve: "Approve",
                reject: "Reject",
            },
            noData: "No employee has submitted a driving allowance for the selected month yet"
        },
        timeRegistration: {
            title: "Time Registration",
            noEmployeeSelected: "No employee selected",
            search: "Search...",
            totalHours: "Worked Hours",
            oughtToHours: "Ought to have worked",
            departments: "Departments",
            selectEmployee: "Select an Employee from the List",
            month: "Month",
            overviewTitle: "Overview of Worked Hours for this year",
            totalWorkedHours: "Total worked hours",
            totalOughtToHours: "Total ought to have worked hours",
        },
        analytics: {
            loading: "Loading Analytics...",
            dateRangeControls: {
                last7days: "Last 7 Days",
                week: "Week",
                month: "Month",
                year: "Year",
                customRange: "Custom Range",
                dateRangeLabel: "Date Range"
            },
            modal: {
                errorTitle: "Something went wrong...",
                successTitle: "Download Successful!",
                loadingLabel: "Retrieving Data File...",
                downloadReportFor: "Download Report for:",
                to: "to",
                cancel: "Cancel",
                download: "Download",
                downloadReport: "Download Report"
            },
            distance: {
                title: "Total Distance",
                unit: "km",
                tooltipFormat: "{{value}} km"
            }
        },
        emissions: {
            emissions: {
                title: "CO₂ Emissions",
                unit: "kg",
                increased: "You spent {{value}} kg compared to the last time period",
                decreased: "You saved {{value}} kg this time period",
                chart: {
                    downloadButton: "Download Custom CSV",
                    day: "Day",
                    date: "Date",
                    emission: "Emission",
                    total: "Total",
                    months: [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                    ]
                }
            },
            commutes: {
                title: "Amount of commutes",
                seriesName: "Commutes"
            },
            distance: {
                title: "Total Distance",
                unit: "km",
                seriesName: "Distance",
                tooltipFormat: "{{value}} km"
            },
            transport: {
                mostUtilizedValue: "Car",
                mostUtilizedTitle: "Most Utilized Transportation Method",
                tooltipFormat: "{{value}} km",
                legendFormat: "{{seriesName}}: {{distance}} km",
                activityTypes: {
                    car: "Car",
                    bus: "Bus",
                    train: "Train",
                    walking: "Walking",
                    cycling: "Cycling",
                    metro: "Metro"
                },
                methods: {
                    car: "Car",
                    bus: "Bus",
                    train: "Train",
                    walking: "Walking",
                    cycling: "Cycling",
                    metro: "Metro"
                }
            }
        },
        employees: {
            title: "All Users",
            breadcrumb: {
                dashboard: "Dashboard",
                allEmployees: "All Employees"
            },
            tableHeaders: {
                user: "User",
                userRole: "User Role",
                department: "Department",
                status: "Status"
            },
            pagination: {
                showing: "Showing",
                of: "of",
                previous: "Previous",
                next: "Next"
            },
            loading: "Loading Employees...",
            employeeCell: {
                roles: {
                    owner: "Owner",
                    administrator: "Administrator",
                    employee: "Employee"
                },
                status: {
                    active: "Active",
                    removed: "Removed"
                },
                noSelection: "Hasn't Selected",
                delete: "Delete"
            },
            actions: {
                deleteSelected: "Delete Selected",
            },
            confirmDelete: {
                title: "Confirm Deletion",
                message: "Are you sure you want to delete the selected {{count}} employees? This action cannot be undone.",
                cancel: "Cancel",
                confirm: "Yes, Delete",
            }
        },
        departments: {
            title: "All Departments",
            breadcrumb: {
                dashboard: "Dashboard",
                allDepartments: "All Departments"
            },
            tableHeaders: {
                departmentName: "Department Name",
                employeeCount: "Employee Count",
                activeEmployees: "Active Employees",
                totalEmissions: "Total Emissions",
                avgEmissions: "Avg. Employee Emissions"
            },
            actions: {
                addDepartment: "Add Department",
                updateDepartment: "Update Department",
                search: "Search"
            },
            modal: {
                add: "Add Department",
                update: "Update Department",
                departmentName: "Department Name",
                departmentNamePlaceholder: "Department name",
                employeeCount: "Employee Count",
                employeeCountPlaceholder: "Employee Count",
                departmentColor: "Department Color (For Analytics)",
                travelsForBusiness: "Travels for business"
            },
            pagination: {
                showing: "Showing",
                of: "of",
                previous: "Previous",
                next: "Next"
            },
            loading: "Loading Departments...",
            toasts: {
                updating: "Updating Department...",
                updated: "Department updated successfully",
                creating: "Creating Department...",
                created: "Department created successfully",
                removing: "Removing Department...",
                removed: "Department removed successfully"
            },
            delete: "Delete",
            confirm: {
                title: "Delete Department",
                message: "Are you sure you want to delete this department?",
                cancel: "Cancel",
                confirm: "Yes, delete"
            }
        },
        offices: {
            title: "Offices",
            breadcrumb: {
                dashboard: "Dashboard",
                allOffices: "All Offices"
            },
            loading: "Loading Offices...",
            actions: {
                addOffice: "Add Office",
                updateOffice: "Update Office",
                search: "Search"
            },
            tableHeaders: {
                officeName: "Office Name",
                employeeCount: "Employee Count",
                address: "Address",
                city: "City",
                zip: "ZIP Code"
            },
            pagination: {
                showing: "Showing",
                to: "to",
                of: "of",
                offices: "offices",
                previous: "Prev",
                next: "Next"
            },
            cell: {
                delete: "Delete",
                confirm: {
                    title: "Confirm Delete",
                    message: 'Are you sure you want to delete the office "{{officeName}}"? This action cannot be undone.',
                    cancel: "Cancel",
                    confirm: "Delete"
                }
            },
            drawer: {
                newTitle: "New Office",
                editTitle: "Edit Office",
                closeMenu: "Close menu",
                location: "Office Location",
                name: "Office Name",
                namePlaceholder: "Office Name",
                nameValidation: "Please write at least 1 letter.",
                address: "Office Address",
                addressPlaceholder: "Office Address",
                addressValidation: "Please include both street name and number.",
                employeeCount: "Employee Count",
                employeeCountPlaceholder: "Employee Count",
                color: "Office Color (For Analytics)",
                discard: "Discard",
                add: "Add Office",
                update: "Update Office"
            }
        },
        settings: {
            modal: {
                general: "General",
                organizationInfo: "Organization Info",
                contactSupport: "Contact Support",
                billing: "Billing",
                paymentInfo: "Payment Info",
                invoices: "Invoices",
                logout: "Logout"
            },
            general: {
                title: "User settings",
                breadcrumb: {
                    dashboard: "Dashboard",
                    settings: "Settings"
                },
                userProfile: {
                    uploadImage: "Upload image",
                    changeImage: "Change image",
                    removeImage: "Remove image",
                    maxSize: "JPG, GIF or PNG. Max size of 800KB",
                    userRoles: {
                        owner: "Organization Owner",
                        admin: "Organization Administrator",
                        employee: "Organization Employee"
                    }
                },
                socialAccounts: {
                    title: "Social accounts",
                    socialMedia: "Social media",
                    accountLinked: "Account linked",
                    noAccountLinked: "No account linked",
                    google: "Google",
                    apple: "Apple",
                    comingSoon: "Coming soon"
                },
                generalInfo: {
                    firstName: "First Name",
                    lastName: "Last Name",
                    email: "Email",
                    phoneNumber: "Phone Number",
                    department: "Department",
                    office: "Office",
                    noSelection: "No Selection",
                    selectDepartment: "Select Department",
                    selectOffice: "Select Office",
                    saveChanges: "Save Changes"
                },
                password: {
                    title: "Password information",
                    currentPassword: "Current Password",
                    newPassword: "New Password",
                    confirmPassword: "Confirm Password",
                    updatePassword: "Update Password",
                    requirements: "Password requirements:",
                    requirementList: [
                        "At least 10 characters (and up to 100 characters)",
                        "At least one lowercase character",
                        "Inclusion of at least one special character, e.g., ! @ # ?"
                    ]
                }
            },
            organization: {
                title: "Organization information",
                name: "Organization Name",
                registrationNumber: "Registration Number",
                contactEmail: "Contact Email",
                emailSuffix: "Email Suffix",
                employeeCount: "Employee Count",
                saveChanges: "Save Changes"
            },
            billing: {
                title: "Billing",
                breadcrumb: {
                    home: "Home",
                    settings: "Settings",
                    billing: "Billing"
                },
                intro: {
                    title: "Drivn",
                    description: "Switch your subscription to a different type, such as a monthly plan, annual plan, or student plan. And see a list of subscription plans that Drivn offers.",
                    nextPayment: "Next payment of $36 (yearly) occurs on August 13, 2024.",
                    changePlan: "Change Plan",
                    cancelSubscription: "Cancel Subscription"
                },
                generalInfo: {
                    title: "Billing Information",
                    firstName: "First Name",
                    lastName: "Last name",
                    organization: "Organization",
                    department: "Department",
                    city: "City",
                    role: "Role",
                    country: "Country",
                    email: "Email",
                    saveChanges: "Save Changes"
                },
                cardDetails: {
                    title: "Card Details",
                    fullName: "(Full name as displayed on card)*",
                    cardNumber: "Card Number *",
                    cvc: "CVC",
                    postalCode: "Postal / ZIP code (optional)",
                    saveChanges: "Save Changes"
                }
            },
            analytics: {
                transport: {
                    activityTypes: {
                        car: "Car",
                        bus: "Bus",
                        train: "Train",
                        bike: "Bike",
                        walk: "Walk",
                        other: "Other"
                    },
                    mostUtilizedTitle: "Most Utilized Transport Type",
                    tooltipFormat: "{{value}} km",
                    legendFormat: "{{seriesName}}: {{distance}} km"
                }
            }
        }
    }
};

export default enTranslation;